import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import formValueSelector from "redux-form/lib/formValueSelector";
import Immutable from "immutable";

import SchemaField from "../../../component/SchemaField";

/**
 * AddressTypeServiceDatetime
 */
class AddressTypeServiceDatetime extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    schema: PropTypes.instanceOf(Immutable.Map).isRequired,
    ctxIdx: PropTypes.number.isRequired,
    addressType: PropTypes.string,
    deliveryDate: PropTypes.string
  };

  static defaultProps = {
    deliveryDate: null,
    addressType: null
  };

  render() {
    const { addressType, t, deliveryDate } = this.props;
    if (addressType !== "funeral center" && addressType !== "church") {
      return null;
    }
    if (!deliveryDate) {
      return null;
    }
    const addressTypesStrings = t("addressTypeAdditions", {
      returnObjects: true
    });
    const addressTypeStrings = addressTypesStrings[addressType] || [];
    return (
      <div className="Cart__Recipient__AddressTypeServiceDatetime">
        <SchemaField
          deliveryDate={this.props.deliveryDate}
          name={`recipients[${this.props.ctxIdx}].address.addition2`}
          label={addressTypeStrings[1]}
          placeholder={addressTypeStrings[1].toLowerCase()}
          note={t("this extra information can be important for the delivery of the funeral flowers")}
          schema={this.props.schema.setIn(
            ["properties", "recipients", "items", "properties", "address", "properties", "addition2", "format"],
            "datetime-local"
          )}
        />
      </div>
    );
  }
}

const cartFormValueSelector = formValueSelector("cart");

export default translate()(
  connect((state, props) => ({
    schema: state.cart.get("schema"),
    addressType: cartFormValueSelector(state, `recipients[${props.ctxIdx}].address.addressType`),
    deliveryDate: cartFormValueSelector(state, `recipients[${props.ctxIdx}].delivery.date`)
  }))(AddressTypeServiceDatetime)
);
